/** Shared label formatting for the command palette + prompt modals. */

/** "verify-spec" / "find_in_workspace" → "Verify spec" / "Find in workspace". */
export function humanizePromptName(name: string): string {
  const s = name.replace(/[-_]+/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** "page_id" → "Page id" — argument field label. */
export function humanizeArgName(name: string): string {
  const s = name.replace(/[-_]+/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}
